import { render, staticRenderFns } from "./UserTrackingAvatar.vue?vue&type=template&id=0a52426f&scoped=true"
import script from "./UserTrackingAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTrackingAvatar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserTrackingAvatar.vue?vue&type=style&index=0&id=0a52426f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a52426f",
  null
  
)

export default component.exports